import locale from "localization/en";

export const nonCashSummaryColumn = [
  { key: "method", text: locale.paymentMethod },
  { key: "transactionCount", text: locale.noOfTransactions },
  { key: "totalAmount", text: locale.amount },
  {
    key: "discount",
    text: (
      <>
        {locale.discount} /<br /> {locale.premium}
      </>
    ),
  },
  { key: "finalAmount", text: locale.finalAmount },
  { key: "actions", text: "" },
];

export const nonCashTransactionColumn = [
  {
    key: "paymentMethod",
    text: locale.referenceNo,
  },
  {
    key: "amount",
    text: locale.amount,
    style: {
      minWidth: "80px",
    },
  },
  {
    key: "discount",
    text: (
      <>
        {locale.discount} / <br />
        {locale.premium}
      </>
    ),
    style: {
      minWidth: "100px",
    },
  },
  {
    key: "finalAmount",
    text: locale.finalAmountPaid,
    style: {
      minWidth: "100px",
    },
  },
  { key: "transactionId", text: locale.transactionNo },
  { key: "product", text: locale.product },
  { key: "pumpNumber", text: locale.pumpNumber },
  { key: "quantity", text: locale.quantity },
  {
    key: "refName",
    text: (
      <span>
        {locale.refName} /<br />
        {locale.plateNumber}
      </span>
    ),
    style: {
      minWidth: "100px",
    },
  },
  { key: "remarks", text: locale.remarks },
];
